<div class="skulist-result-table"
  *ngIf="_shipmentPlanPreview && _shipmentPlanPreview.length !==0 ">
  <mat-table #table [dataSource]="dataSource">
    <ng-container matColumnDef="destinationId">
      <mat-header-cell *matHeaderCellDef>WH ID </mat-header-cell>
      <mat-cell *matCellDef="let element" class="mid_grey2" (click)="toggleRow(element)"[matTooltip]="element.shipmentId">
        <span class="pe-2"><i [ngClass]="element.expanded ? 'fal fa-angle-down': 'far fa-angle-right'"></i></span>
        <span>{{element.destinationId}}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="skuCount">
      <mat-header-cell *matHeaderCellDef> SKUs </mat-header-cell>
      <mat-cell *matCellDef="let element" class="mid_grey2" (click)="toggleRow(element)"> {{element.skuCount}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Qty">
      <mat-header-cell *matHeaderCellDef> Qty </mat-header-cell>
      <mat-cell *matCellDef="let element" class="mid_grey2" (click)="toggleRow(element)"> {{element.Qty}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="shipTo">
      <mat-header-cell *matHeaderCellDef> State </mat-header-cell>
      <mat-cell *matCellDef="let element" class="mid_grey2" (click)="toggleRow(element)"> {{element.shipTo}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="pctMatch">
      <mat-header-cell *matHeaderCellDef>Match Score</mat-header-cell>
      <mat-cell *matCellDef="let element" class="mid_grey2" (click)="toggleRow(element)">
        <span class="match"

          [ngClass]="{'match-gray': element.pctMatch.pctMatch < 85,'match-success': element.pctMatch.pctMatch >= 85 }">{{round(element.pctMatch.pctMatch) }}%
          <i class="fal fa-lock active fas fa-lock m-1" *ngIf="element.hasLockedSkus" matTooltip="Locked item excluded from the score"></i></span>

      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="millage">
      <mat-header-cell *matHeaderCellDef> Distance </mat-header-cell>
      <mat-cell *matCellDef="let element" class="mid_grey2" (click)="toggleRow(element)"> {{element.millage | number: '1.0-0'}} mi</mat-cell>
    </ng-container>

    <ng-container matColumnDef="shipmentHeaderId">
      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
      <mat-cell *matCellDef="let element" class="mid_grey2">
        <div class="shipment_title d-flex" *ngIf="element.shipmentHeaderId && element.planCreated">
          <span class="shipment_name me-2 shipment_link" [routerLink]="['/shipyard/shipments/detail', element.shipmentHeaderId]">
            {{element.shipmentId}}
          </span>
          <i class="fal icon text-primary" [ngClass]="{ 'fa-copy': !element?.copied, 'fa-check': element.copied }"
          [cdkCopyToClipboard]="element.shipmentId" (cdkCopyToClipboardCopied)="copy($event,element)">
        </i>
        </div>
        <div class="text-end w-100" *ngIf="element.pctMatch.pctMatch < 100 && !element.planCreated" [matTooltip]="'Try combining all to this FC'">
          <span class="add-shipment" [ngClass]="{'disabled':element.disable}" (click)="planAllAdded(element)"><img
              src="assets/images/loading.gif" class="loader-img me-1" *ngIf="element.loader"/>Round Up</span>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="export">
      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
      <mat-cell *matCellDef="let element" class="mid_grey2">
        <div class="add-plan text-center">
          <span class="add-plan-btn primary"
            [ngClass]="{'disabled': element.planCreated || shipyardService.loadCreateShipment}"
            (click)="exportShipment(element)" matTooltip="Export plan results">
            <svg width="10" height="12" class="mb-1"><use xlink:href="assets/images/sprite-icons.svg#file-arrow-down"></use></svg>
          </span>
        </div>
      </mat-cell>
    </ng-container>
    
    <ng-container matColumnDef="create">
      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
      <mat-cell *matCellDef="let element" class="mid_grey2">
        <div class="add-plan text-end">
          <span class="add-plan-btn primary" matTooltip="Review all  plans and Create"
            [ngClass]="{'disabled': element.planCreated || shipyardService.loadCreateShipment}"
            (click)="create(element)"><img src="assets/images/loading.gif" class="loader-img me-1"
            *ngIf="element.loading" />Proceed</span>

        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <mat-cell *matCellDef="let detail" class="skulist-cell sku-detail">
        <ng-container *ngFor="let sku of detail.element.skus">
          <div class="sku-detail-view">
            <app-sku-view [sku]="sku" [isCaseQty]="isCaseQty"></app-sku-view>
            <span class="sku_lock text-primary hand m-auto"  *ngIf="sku.isQtyLocked">
              <i class="fal fa-lock active fas fa-lock" aria-hidden="true"></i>
            </span> 
            <span class="m-auto" *ngIf="((sku.qty || sku.Qty) - sku.originalQty) == 0">
              <i class="fas fa-check" style="color: #5ac936; font-size: 10px;"></i>
            </span>
            <div class="skuqty">
              <span class="label">Qty</span>
              <span class="qty-box">{{sku.qty}}<p class="qty-box_difference" *ngIf="(sku.qty) - sku.originalQty">{{(sku.qty) - sku.originalQty}}</p></span>
            </div> 
          </div>
        </ng-container>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"
      [class.expanded]="row.expanded" [class.element-row-border-blue]="row.planCreated"></mat-row>
    <mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpansionDetailRow"
      [@detailExpand]="row.element.expanded ? 'expanded' : 'collapsed'" style="overflow: hidden">
    </mat-row>
  </mat-table>
</div>